import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import { LocationDto } from "../../../../../dto/Location/LocationDto";
import { LocationResolutionResponseDto } from "../../../../../dto/LocationResolution/LocationResolutionDto";
import endPoints from "./locationResolution.endpoints";
import {
  ConfirmLocationResolutionRequestDto,
  ReverseGeocodeLocationRequestDto,
  SearchLocationResolutionRequestDto,
} from "./locationResolution.requestsDto";

const locationResolutionApi = {
  search: function* (dto: SearchLocationResolutionRequestDto) {
    return (yield call(
      [backOfficeApiService, backOfficeApiService.Post],
      endPoints.search,
      dto,
    )) as ApiCallResult<LocationResolutionResponseDto>;
  },
  reverseGeocode: function* (resolutionId: string, dto: ReverseGeocodeLocationRequestDto) {
    return (yield call(
      [backOfficeApiService, backOfficeApiService.Post],
      endPoints.reverseGeocode(resolutionId),
      dto,
    )) as ApiCallResult<LocationResolutionResponseDto>;
  },
  confirm: function* (resolutionId: string, dto: ConfirmLocationResolutionRequestDto) {
    return (yield call(
      [backOfficeApiService, backOfficeApiService.Post],
      endPoints.confirm(resolutionId),
      dto,
    )) as ApiCallResult<LocationDto>;
  },
};

export default locationResolutionApi;
